import { UseQueryResult } from '@tanstack/react-query';
import { graphql } from '../gql';
import { useApiQuery } from '../query/hooks';
import { Journey_DisplayMetricQuery } from '../gql/graphql';

type ContentMetric = Readonly<{
	id: string;
	activities?: Readonly<{ name: string }[]> | null;
	metric?: Readonly<{
		id: string;
	}> | null;
}>;

const displayMetricQuery = graphql(`
	query journey_displayMetric(
		$id: UUID!
		$compareStart: DateTime!
		$compareEnd: DateTime!
		$targetStart: DateTime!
		$targetEnd: DateTime!
	) {
		displayMetric(id: $id) {
			name
			expectations
			precision
			trendComparison
			values(compareRange: { start: $compareStart, end: $compareEnd }, targetRange: { start: $targetStart, end: $targetEnd }) {
				targetValue
				comparedValue
				comparison
				lastUpdateAt
			}
		}
	}
`);

type ContentMetricProps = Readonly<{
	contentMetric: ContentMetric;
	compareStart: string;
	compareEnd: string;
	targetStart: string;
	targetEnd: string;
}>;

const useContentMetric = ({
	compareEnd,
	compareStart,
	contentMetric,
	targetEnd,
	targetStart,
}: ContentMetricProps): UseQueryResult<Journey_DisplayMetricQuery, unknown> => {
	const result = useApiQuery(displayMetricQuery, {
		variables: {
			id: contentMetric.metric?.id ?? '',
			compareStart,
			compareEnd,
			targetStart,
			targetEnd,
		},
		enabled: contentMetric.metric != null,
		placeholderData: (previousData) => previousData,
	});
	return result;
};

export { type ContentMetric, useContentMetric };
